$(document).ready(() => {

  // Hamburger Menu
  $('.hamburger').click(function () {
    $(this).toggleClass('is-active');
  });

  // Wrap each dropdown menu so it can be columnized
  $('.dropdown-menu').wrapInner('<nav class="navbar-submenu"></nav>');

  // Prepend the dropdown menu's title (based on its parent item) to each menu
  $('.navbar-submenu').each(function () {
    var toggle = $(this).closest('.menu-item').find('.dropdown-toggle');
    var title = toggle[0].innerHTML;
    $(this).prepend('<div class="d-block d-sm-none">' +
      '<aside class="close-menu mb-3"><a href="#" class="ps-3">&lt; Back</a></aside>' +
      '<h6 class="dropdown-header">' + title + '</h6></div>');
  });

  //End of Script
});
